<template>
  <div id="app">
    <warningdlg>
      <el-button
        v-for="(item,index) in $store.state.warning.button"
        :key="index"
        :id="true?item.name:''"
        @click="item.callBack"
      >{{item.name}}</el-button>
    </warningdlg>
    <router-view />
    <addgroupdlg>
      <button
        v-for="(item,index) in $store.state.groupObj.button"
        :key="index"
        type="button"
        :id="true?item.name:''"
        class="btn btn-block btn-primary"
        @click="item.callBack"
      >{{item.name}}</button>
    </addgroupdlg>
    <poiListdlg>
    </poiListdlg>
    <eventListdlg>
    </eventListdlg>
  </div>
</template>
<script>
import warningDlg from "./components/common/warningDlg";
import addGroupDlg from "./components/common/addGroupDlg";
import poiListDlg from "./components/common/poiListDlg";
import eventListDlg from "./components/common/eventListDlg";
import eventBus from "./eventbus";

export default {
  name: "app",
  components: {
    warningdlg: warningDlg,
    eventListdlg: eventListDlg,
    poiListdlg:poiListDlg,
    addgroupdlg: addGroupDlg,
  },
  methods: {
    warningBtn(data) {
      eventBus.$emit("warningBtn", data);
    }
  }
};
</script>

